import { ProductSource, ProductType } from '../../types/product'
import { bff } from '../../env'
import { TimeslotList } from '@studio/atomic-ui'

const endpoint = `${bff}/bookings/check-availability`

export type CheckAvailabilityParams = {
  bookingSource: ProductSource
  location: string
  productId: string
  productType: ProductType
  startDate: string
  endDate: string
  /** Value in float format, beginning with 0.5 in steps of 0.5 up until 8 (in hours) */
  duration?: string
  startTime?: string
}

export type ProductAvailability = {
  isAvailable: boolean
  startTimes?: TimeslotList[]
}

export interface DayPassResponse {
  availableDesks: number
}

/** This endpoint can be used for two purposes:
 *  - Checking the timeslots available for **a given day (not date)** and duration, checking the `startTimes` response.
 *  - Checking the `isAvailable` flag for availability for a given date range
 **/
export const checkAvailability = async (params: CheckAvailabilityParams): Promise<ProductAvailability> => {
  const url = new URL(endpoint)
  url.searchParams.set('bookingSource', params.bookingSource)
  url.searchParams.set('location', params.location)
  url.searchParams.set('productId', params.productId)
  url.searchParams.set('startDate', params.startDate)
  url.searchParams.set('endDate', params.endDate)
  url.searchParams.set('productType', params.productType)
  if (params.duration) url.searchParams.set('duration', params.duration)
  if (params.startTime) url.searchParams.set('startTime', params.startTime)

  const request = await fetch(url)

  return request.json()
}

export const getCheckDayPassAvailability = async (
  startDate: string,
  endDate: string,
  location: string,
  bookingSource: string
): Promise<DayPassResponse> => {
  const url = new URL(`${bff}/bookings/desk-availability`)
  url.searchParams.set('startDate', startDate)
  url.searchParams.set('endDate', endDate)
  url.searchParams.set('location', location)
  url.searchParams.set('bookingSource', bookingSource)
  const response = await fetch(url)
  return response.json()
}
